<template>
  <v-container>
    <h1>BIENVENIDO A SIDRA</h1>
<!--    Location: {{ loc.href }} -->
    <p>
      <v-btn v-on:click="toAuth" v-if="authNeeded">Entrar a SIDRA</v-btn>
<!--      <v-btn v-on:click="next">Siguiente</v-btn> -->
    </p>
  </v-container>
</template>

<script>
import Vue from 'vue';
import {API, settings} from '@/api';
import interceptorsSetup from '@/util/axios-interceptor2';
// import axios from 'axios';
// import oauth from 'axios-oauth-client';

export default {
  data() {
    return {
      type    :  settings.auth.type,
      user_pool_domain: settings.auth.user_pool_domain,
      tokenUrl:  settings.auth.tokenUrl,
      clientId:  settings.auth.clientId,
      ret:       settings.auth.ret,
      retlogout: settings.auth.retlogout,
      nextName:  'administraciones',
      checkUrl:  '/user/current',
      loc :      '',
      authNeeded: false,
    };
  },
  props: {
      logout: Boolean,
    },
  async mounted() {
    console.debug('Login auth.identityPool: %o', settings.auth.identityPool);

    if (this.logout === true) {
      console.log('LOGOUT');
      await this.$store.dispatch('logout');
      // window.localStorage.removeItem('authorization');
      // window.location.href =
      // `https://${this.user_pool_domain}/logout?client_id=${this.clientId}&logout_uri=${this.retlogout}`;
    }
    const url = new URL(this.loc, location);
    this.loc = window.location;
    console.debug('url.hash: %s', url.hash);

    const search = this.urlToObj(url.search.substring(1));
    const code = search.code;
    // Si tiene un code => AWS cognito token => interceptorsSetup()
    if (code) {
      this.withCode(code);
//      this.$router.push({name: 'login'}); //why
//      return;
    }

    // Si tiene un token +valido? => next()
    API.get(this.checkUrl).then( (response) => {
      console.error('checkurl: %s %o %o', this.checkUrl, response.status, response.data);
      if (response.status === 200) {
        this.$store.dispatch('setUser', response.data);
        this.next();
        return;
      // si no tiene nada, redirect a AWS => auth()
      } else {
        this.$toast.warning(`Error: ${response.status}`);
      }
    })
    .catch( (e) => {
      this.authNeeded = true;
      if (e.response.status === 401) {
        this.$toast.warning(`Su sesión ha expirado`);
        console.warn(`${e.status}: Su sesión ha expirado (catch)`);
        // this.toAuth();
        // this.authNeeded = true;
        return;
      }
      if (e.response.status === 403) {
        this.$toast.warning(`Su sesión ha expirado`);
        console.warn(`${e.status}: Su sesión ha expirado (catch)`);
        // this.toAuth();
        // this.authNeeded = true;
        return;
      }
      console.error('Error no controlado (codigo desconocido): %d %o %o', e.response.status, e.response.data, e);
      this.$toast.error('Error no controlado ' + e.response.status);
    });
    /*
    if (url.hash) {
      this.withToken(url);
    } */
  },
  methods: {
    async check() {
//      console.debug('Backend: inicio: ' + Date.now());
      const response = await API.get(this.checkUrl);
      console.debug('check: %o', response);
      console.info('Backend: ' + response.status + ' ' + response.data + ' ' + Date.now());


    },
    async toAuth() {
//      const type = 'code'; // authorization code grant
      // const type = 'token'; // implicit grant <= no refresh
      this.$toast.info(`Redirgiendo a autenticacion`);
      window.location.href = `https://${this.user_pool_domain}/login?response_type=${this.type}&client_id=${this.clientId}&redirect_uri=${this.ret}`;
    },

    next() {
      this.$router.push({name: this.nextName});
    },
    async withToken(url) {

      const hash2Obj = this.urlToObj(url.hash.substring(1));

      console.debug(hash2Obj);


//  Lineas => Prueba para authorization
      window.localStorage.removeItem('authorization');
      window.localStorage.setItem('authorization', JSON.stringify(hash2Obj));
// fin de prueba
      if (url.hash) {
        // FIXME Miguel, nunca se está guardando el authorization al hacer login.
        window.localStorage.removeItem('authorization');
        //  window.localStorage.setItem('authorization', url.hash); // guardar JWT Token
        window.localStorage.setItem('authorization', JSON.stringify(hash2Obj)); // guardar JWT Token
      }

      const userInfoUrl = `https://${this.user_pool_domain}/oauth2/userInfo`;
      const userInfo = await API.get(userInfoUrl);
      console.debug('userinfo %o', userInfo.data);
    },

    async withCode(code) {

      const tokenUrl = `https://${this.user_pool_domain}/oauth2/token`;
//      interceptorsSetup(API, code);
      interceptorsSetup(API, {tokenUrl, clientId: this.clientId, ret: this.ret});
      console.debug('code %s ', code);
    },

    urlToObj(str) {
      return str
        .split('&')
        .map((v) => v.split('='))
        .reduce( (pre, [key, value]) => ({ ...pre, [key]: value }), {} );
    },
  },
};
</script>
